const WORKERS_ON_DEMAND = {
  OPEN_LEGACY: 'WORKERS_ON_DEMAND:OPEN_LEGACY',
};

export default WORKERS_ON_DEMAND;
